

export const DELAYS = {
  SHORT: 300,
  MEDIUM: 500,
  LONG: 1000,
} as const;

/**
 * Simulate network delay
 */
export function delay(delayValue: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, delayValue));
}
